// Which row describes the task the drawer is showing.
//
// The drawer is handed a row and also fetches the full one, and those two can
// disagree while a fetch is in flight: opening task B leaves the answer for task A
// on hand. Everything here therefore turns on identity — a row that belongs to
// another task describes nothing about this one, not even its associations, which
// used to be merged in without checking whose they were (LF360-1852).
export const resolveViewTask = (task, fetchedTask) => {
  if (!fetchedTask) { return task; }
  if (!task) { return fetchedTask; }

  // the fetch still answers for the task we came from
  if (String(fetchedTask.id) !== String(task.id)) { return task; }

  const fetchedAt = new Date(fetchedTask.updatedAt || 0).getTime();
  const givenAt = new Date(task.updatedAt || 0).getTime();
  const base = givenAt >= fetchedAt ? task : fetchedTask;

  // the fetch carries associations the row it was given may not have
  if (base && !base.associations && fetchedTask.associations) {
    return { ...base, associations: fetchedTask.associations };
  }

  return base;
};

export default resolveViewTask;
